import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import Keycloak from 'keycloak-js';
import { DEFAULT_POST_LOGIN_PATH, sanitizeReturnUrl } from './return-url';

export const redirectIfAuthenticatedGuard: CanActivateFn = (route) => {
  const keycloak = inject(Keycloak);
  const router = inject(Router);

  if (!keycloak.authenticated) {
    return true;
  }

  // Chi arriva su /home già autenticato (sessione SSO ancora valida, quindi
  // senza passare dal bottone di login) deve comunque finire sulla pagina
  // richiesta dal link, non sulla dashboard.
  const returnUrl = sanitizeReturnUrl(route.queryParamMap.get('returnUrl'));

  return router.parseUrl(returnUrl ?? DEFAULT_POST_LOGIN_PATH);
};
